import AddSkillModal from './AddSkillModal'

export default AddSkillModal
